// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"b0e68526","329":"de6daff2","770":"5b4b4517","945":"9439dafd"}[chunkId] + ".chunk.js";
};